import { render, staticRenderFns } from "./AddBasicPrice.vue?vue&type=template&id=4b04239d&"
import script from "./AddBasicPrice.vue?vue&type=script&lang=js&"
export * from "./AddBasicPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports